// extracted by mini-css-extract-plugin
export default {"portrait_modal":"PortraitModal_portrait_modal__vyBgN","mobile_icon":"PortraitModal_mobile_icon__zc-FT","rotate":"PortraitModal_rotate__BLTbD"};